'use client';

import { styled } from 'styled-components';
import * as Styled from '@lib/styles';
import Link from 'next/link';
import { CURRENT_YEAR } from './Footer';

const MiniFooterWrapper = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: ${({ theme }) => theme.spacing[2]};
  padding-inline: ${({ theme }) => theme.spacing[2]};

  ${({ theme }) => theme.mq.minWidth.large} {
    padding-inline: ${({ theme }) => theme.spacing[4]};
  }
`;

const MiniFooterLink = styled(Link)`
  color: var(--global-text-color);
  font-size: ${({ theme }) => theme.typography.fontSize.bodySm};
  font-weight: ${({ theme }) =>
    // Override the global styles since fontWeight.body is different than fontWeight.link
    theme.typography.fontWeight.body} !important;

  &:hover,
  &:active {
    text-decoration: underline currentColor;
  }

  ${({ theme }) => theme.mq.minWidth.large} {
    font-size: ${({ theme }) => theme.typography.fontSize.desktop.bodySm};
  }
`;

const MiniFooterContent = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[0.75]};

  ${({ theme }) => theme.mq.minWidth.small} {
    justify-content: space-between;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing[1]};
  }

  ${({ theme }) => theme.mq.minWidth.medium} {
    gap: ${({ theme }) => theme.spacing[4]};
  }

  p {
    margin: 0;
  }
`;

/**
 * MiniFooter is a component that displays a footer with links and a copyright notice.
 * It should only be used in the landing pages of the website.
 */
const MiniFooter = () => {
  return (
    <MiniFooterWrapper>
      <MiniFooterContent>
        <MiniFooterLink href="/terms">Terms of Service</MiniFooterLink>
        <MiniFooterLink href="/privacy">Privacy Policy</MiniFooterLink>
        <Styled.BodySm>{`© ${CURRENT_YEAR} Wistia`}</Styled.BodySm>
      </MiniFooterContent>
    </MiniFooterWrapper>
  );
};

export default MiniFooter;
